<template>
    <td-dialog
        :lockScroll="false"
        :title="$t(elementTitle)"
        :before-close="elementDialogClose"
        :visible.sync="dialogVisible"
        width="690px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
        append-to-body
    >
        <el-form :model="formGroupElementInfo" label-position="right" label-width="95px" ref="formGroupElementInfo" :rules="rules">
            <el-row :gutter="11">
                <el-col :span="11" v-if="showNameFlag">
                    <el-form-item :label="$t('extendCommon.SHOW_NAME')" prop="showName">
                        <td-input v-model="formGroupElementInfo.showName" maxlength="50"> </td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item :label="$t('extendCommon.SHOW_NAME')" prop="sViewName" v-if="!showNameFlag">
                        <td-select
                            v-model="formGroupElementInfo.sViewName"
                            :url="viewUrl"
                            :urlParam="viewUrlParam"
                            :isPage="true"
                            :pageSize="10"
                            requestType="POST"
                            keys="sElementFlg"
                            text="sName"
                            :sName="sName"
                            :disabled="elementDisabled"
                        >
                        </td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item :label="$t('pgCommon.BELONG_TO_GROUP')" prop="sGroupId">
                        <td-select v-model="formGroupElementInfo.sGroupId" :disabled="true" :options="optionsGroup" keys="taskKey" text="taskName" :clearable="false" @change="groupChange"></td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item :label="$t('pgCommon.ELEMENT_TYPE')" prop="elementType">
                        <td-select v-model="formGroupElementInfo.elementType" :options="optionsElement" @change="elementChange" :disabled="elementTypeDisabled"></td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdUploadX'">
                    <el-form-item :label="$t('pgCommon.ACCEPT')" prop="accept">
                        <td-input v-model="formGroupElementInfo.sElementPropsJson.accept" maxlength="50" :placeholder="$t('pgMessage.DEFAULT_ACCEPT')"> </td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdUploadX'">
                    <el-form-item :label="$t('pgCommon.MESSAGE')" prop="message">
                        <td-input v-model="formGroupElementInfo.sElementPropsJson.message" maxlength="50"> </td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdUploadX'">
                    <el-form-item :label="$t('pgCommon.LIMIT')" prop="limit">
                        <td-input-number v-model="formGroupElementInfo.sElementPropsJson.limit" :min="1" :max="10"> </td-input-number>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdUploadX'">
                    <el-form-item :label="$t('pgCommon.LIMIT_SIZE')" prop="limitSize">
                        <td-input-number v-model="formGroupElementInfo.sElementPropsJson.limitSize" :min="1" :max="50"> </td-input-number>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdUploadX'">
                    <el-form-item :label="$t('pgCommon.FILE_SERVICE_NAME')" prop="serviceId">
                        <td-select
                            v-model="formGroupElementInfo.serviceId"
                            :url="queryConfigInfos"
                            :urlParam="queryConfigInfosParam"
                            :isPage="true"
                            :pageSize="10"
                            requestType="POST"
                            keys="id"
                            text="serviceName"
                            :sName="serviceName"
                            :disabled="elementDisabled"
                        >
                        </td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdUploadX'">
                    <el-form-item :label="$t('pgCommon.IS_BASEFILE')" prop="httpRequest">
                        <td-select v-model="formGroupElementInfo.httpRequest" :options="httpRequests" :disabled="elementDisabled"></td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdButton'">
                    <el-form-item :label="$t('pgCommon.BUTTON_TYPE')" prop="buttonType">
                        <td-select v-model="formGroupElementInfo.sElementPropVal" :options="buttonTypes" :isPage="false"></td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="inputFlag">
                    <el-form-item :label="$t('pgCommon.INPUT_TYPE')" prop="sElementPropVal">
                        <td-select v-model="formGroupElementInfo.sElementPropVal" :options="sElementPropsJsons" :isPage="false"></td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdButton'">
                    <el-form-item :label="$t('pgCommon.BUTTON_SIZE')" prop="buttonSize">
                        <td-select v-model="formGroupElementInfo.buttonSize" :options="buttonSizes" :isPage="false"></td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdButton'">
                    <el-form-item :label="$t('pgCommon.ONCLICK_EVENT')" prop="method">
                        <td-input v-model="formGroupElementInfo.method" maxlength="50"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item :label="$t('extendCommon.SHOW_ORDER')" prop="iOrder">
                        <td-input-number v-model="formGroupElementInfo.iOrder" :min="1" :max="500"> </td-input-number>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdInputNumber'">
                    <el-form-item :label="$t('pgCommon.MIN_NUM')" prop="min">
                        <td-input-number v-model="formGroupElementInfo.sElementPropsJson.min"> </td-input-number>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdInputNumber'">
                    <el-form-item :label="$t('pgCommon.MAX_NUM')" prop="max">
                        <td-input-number v-model="formGroupElementInfo.sElementPropsJson.max"> </td-input-number>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item :label="$t('extendCommon.SHOW_FORMAT')" prop="iColNum">
                        <td-select v-model="formGroupElementInfo.iColNum" :options="optionsFormat" :clearable="false"></td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="inputFlag">
                    <el-form-item :label="$t('pgCommon.PLACE_HOLDER')" prop="placeholder">
                        <td-input v-model="formGroupElementInfo.placeholder" maxlength="100"> </td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="inputFlag">
                    <el-form-item :label="$t('pgCommon.STRING_MAX')" prop="maxlength">
                        <td-input-number v-model="formGroupElementInfo.sElementPropsJson.maxlength" :min="1" :max="4000"> </td-input-number>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="elementWidthFlag">
                    <el-form-item :label="$t('pgCommon.ELEMENT_WIDTH')" prop="width">
                        <td-input v-model="formGroupElementInfo.sElementPropsJson.width" maxlength="5"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item :label="$t('extendCommon.ELEMENT_SHOW_LABEL')">
                        <td-radio v-model="formGroupElementInfo.iShowLabel" :options="requiredType"></td-radio>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item :label="$t('extendCommon.ELEMENT_HIDDEN')">
                        <td-radio v-model="formGroupElementInfo.iHidden" :options="requiredType"></td-radio>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType != 'TdGrid' && formGroupElementInfo.elementType != 'TdUploadX'">
                    <el-form-item :label="$t('extendCommon.ELEMENT_NOT_NULL')">
                        <td-radio v-model="formGroupElementInfo.iNeeded" :options="requiredType"></td-radio>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType != 'TdGrid' && formGroupElementInfo.elementType != 'TdUploadX'">
                    <el-form-item :label="$t('pgCommon.READ_ONLY')">
                        <td-radio v-model="formGroupElementInfo.readOnly" :options="requiredType"></td-radio>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'nextUsers' || formGroupElementInfo.elementType == 'nextGroups' || formGroupElementInfo.elementType == 'showUsers'">
                    <el-form-item :label="$t('pgCommon.TASK_AUTH')" prop="nextAuth">
                        <td-select v-model="formGroupElementInfo.nextAuth" :options="optionsAuths" :disabled="elementDisabled"></td-select>
                    </el-form-item>
                </el-col>
                <el-col
                    :span="11"
                    v-if="
                        formGroupElementInfo.elementType == 'TdSelect' ||
                            formGroupElementInfo.elementType == 'TdTreeSelect' ||
                            formGroupElementInfo.elementType == 'TdGrid' ||
                            formGroupElementInfo.elementType == 'TdUploadX'
                    "
                >
                    <el-form-item :label="$t('pgCommon.ELEMENT_SELECTS')" prop="selects">
                        <td-radio v-model="formGroupElementInfo.selects" :options="requiredType"></td-radio>
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="formGroupElementInfo.elementType == 'TdSelect'">
                    <el-form-item :label="$t('common.EXTENDDATA')"><td-radio v-model="formGroupElementInfo.selectRadio" :options="optionsRadio"></td-radio></el-form-item>
                    <el-form-item :label="$t('pgCommon.SELECT_OPTIONS')" prop="selectOptionsStr" v-if="formGroupElementInfo.selectRadio == 0">
                        <td-input v-model="formGroupElementInfo.selectOptionsStr" type="textarea" :placeholder="optionsDemo" maxlength="1000"> </td-input>
                    </el-form-item>
                    <el-form-item :label="$t('pgCommon.SELECT_OPTIONS')" prop="sTag" v-if="formGroupElementInfo.selectRadio == 1">
                        <td-select v-model="formGroupElementInfo.sTag" :placeholder="$t('common.PLEASE_SELECT')" :options="this.dictDataList" keys="sTag" text="sTag" :clearable="true"> </td-select>
                    </el-form-item>
                    <el-form-item :label="$t('pgCommon.URL')" prop="sUrl" v-if="formGroupElementInfo.selectRadio == 2">
                        <td-input v-model="formGroupElementInfo.sElementPropsJson.url" maxlength="500"> </td-input>
                    </el-form-item>
                    <el-form-item :label="$t('pgCommon.URL_PARAM')" prop="sUrlParam" v-if="formGroupElementInfo.selectRadio == 2">
                        <td-input v-model="formGroupElementInfo.sElementPropsJson.urlParam" maxlength="500"> </td-input>
                    </el-form-item>
                    <el-form-item :label="$t('pgCommon.REQUEST_TYPE')" prop="requestType" v-if="formGroupElementInfo.selectRadio == 2">
                        <td-select v-model="requestType" :placeholder="$t('common.PLEASE_SELECT')" :options="[{ value: 'POST', label: 'POST' }, { value: 'GET', label: 'GET' }]"> </td-select>
                    </el-form-item>
                    <el-form-item :label="$t('pgCommon.SELECT_KEYS')" prop="sKeys" v-if="formGroupElementInfo.selectRadio == 2">
                        <td-input v-model="formGroupElementInfo.sElementPropsJson.keys" :placeholder="$t('pgMessage.DEFAULT_KEYS')" maxlength="50"> </td-input>
                    </el-form-item>
                    <el-form-item :label="$t('pgCommon.SELECT_TEXT')" prop="sText" v-if="formGroupElementInfo.selectRadio == 2">
                        <td-input v-model="formGroupElementInfo.sElementPropsJson.text" :placeholder="$t('pgMessage.DEFAULT_TEXT')" maxlength="50"> </td-input>
                    </el-form-item>
                    <el-form-item :label="$t('pgCommon.CHANGE_EVENT')" prop="changeMethod">
                        <td-input v-model="formGroupElementInfo.changeMethod" maxlength="50"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdTreeSelect'">
                    <el-form-item :label="$t('pgCommon.EXPAND_TREE')">
                        <td-radio v-model="formGroupElementInfo.expand" :options="requiredType"></td-radio>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdTreeSelect'">
                    <el-form-item :label="$t('pgCommon.TREE_SELECT_QUERY')" prop="queryUrl">
                        <td-input v-model="formGroupElementInfo.queryUrl" maxlength="500"> </td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdTreeSelect'">
                    <el-form-item :label="$t('pgCommon.TREE_SELECT_SEARCH')" prop="searchUrl">
                        <td-input v-model="formGroupElementInfo.searchUrl" maxlength="500"> </td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdTreeSelect'">
                    <el-form-item :label="$t('pgCommon.SELECT_KEYS')" prop="defaultPropsId">
                        <td-input v-model="formGroupElementInfo.defaultPropsId" :placeholder="$t('pgMessage.DEFAULT_ID')" maxlength="50"> </td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdTreeSelect'">
                    <el-form-item :label="$t('pgCommon.SELECT_TEXT')" prop="defaultPropsLabel">
                        <td-input v-model="formGroupElementInfo.defaultPropsLabel" :placeholder="$t('pgMessage.DEFAULT_CAPTION')" maxlength="50"> </td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdTreeSelect'">
                    <el-form-item :label="$t('pgCommon.TREE_NODE_KEY')" prop="defaultPropsChildren">
                        <td-input v-model="formGroupElementInfo.defaultPropsChildren" :placeholder="$t('pgMessage.DEFAULT_CHILDREN')" maxlength="50"> </td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdTreeSelect'">
                    <el-form-item :label="$t('pgCommon.PARENT_TREE_NODE_KEY')" prop="defaultPropsParentId">
                        <td-input v-model="formGroupElementInfo.defaultPropsParentId" :placeholder="$t('pgMessage.DEFAULT_PARENTID')" maxlength="50"> </td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdTreeSelect'">
                    <el-form-item :label="$t('pgCommon.IMGNAME_TREE')">
                        <td-input v-model="formGroupElementInfo.sElementPropsJson.defaultProps.imgName" :placeholder="$t('pgMessage.DEFAULT_SICON')" maxlength="50"> </td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdTreeSelect'">
                    <el-form-item :label="$t('pgCommon.PARAMS_THREE')">
                        <td-input v-model="formGroupElementInfo.sElementPropsJson.params" type="textarea" :placeholder="$t('pgMessage.TREE_INPUT_JSON')" maxlength="1000"> </td-input>
                    </el-form-item>
                </el-col>

                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdGrid'">
                    <el-form-item :label="$t('pgCommon.ELEMENT_HEIGHT')" prop="height">
                        <td-input v-model="formGroupElementInfo.sElementPropsJson.height" maxlength="10"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdGrid'">
                    <el-form-item :label="$t('pgCommon.URL')" prop="tableUrl">
                        <td-input v-model="formGroupElementInfo.tableUrl" maxlength="500"> </td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdGrid'">
                    <el-form-item :label="$t('pgCommon.REQUEST_TYPE')" prop="tableResquestType">
                        <td-select
                            v-model="formGroupElementInfo.tableResquestType"
                            :placeholder="$t('common.PLEASE_SELECT')"
                            :options="[{ value: 'POST', label: 'POST' }, { value: 'GET', label: 'GET' }]"
                        >
                        </td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdGrid'">
                    <el-form-item :label="$t('pgCommon.PARAMS_THREE')">
                        <td-input v-model="formGroupElementInfo.sElementPropsJson.urlParam" type="textarea" :placeholder="$t('pgMessage.TREE_INPUT_JSON')" maxlength="1000"> </td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="formGroupElementInfo.elementType == 'TdGrid'">
                    <el-form-item :label="$t('pgCommon.GRID_HEAD_PARAMS')" prop="columnsParam">
                        <td-input v-model="formGroupElementInfo.columnsParam" type="textarea" :placeholder="$t('pgMessage.GRID_HEAD_PARAMS_TIPS')" maxlength="1000"> </td-input>
                    </el-form-item>
                </el-col>

                <!-- radio 与 checkboxgroup-->
                <el-col :span="11" v-if="radioFlag">
                    <el-form-item :label="$t('pgCommon.SELECT')" prop="selectOptionsStr" v-if="formGroupElementInfo.selectRadio == 0">
                        <td-input v-model="formGroupElementInfo.selectOptionsStr" type="textarea" :placeholder="$t('pgCommon.SELECT_BETWEEN_OPTIONS')"></td-input>
                    </el-form-item>
                    <el-form-item :label="$t('pgCommon.CHECKED')" prop="checked">
                        <td-input v-model="formGroupElementInfo.sElementPropsJson.checked"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('formGroupElementInfo')" :loading="submitLoading">{{ $t('extendCommon.SAVE') }}</td-button>
            <td-button @click="elementDialogClose">{{ $t('extendCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import Api from './../assets/api.js';
export default {
    props: ['elementTitle', 'dialogVisible', 'editItem', 'isAddData', 'maxExtendOrder', 'groupId', 'templateId', 'templateKey', 'taskKey', 'taskName'],
    created() {
        this.initGroupList();
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.elementDisabled = true;
            this.keyDisabled = true;
            this.initEditData();
        } else {
            // 默认新增排序字段为当前数据库中最大的排序字段值
            this.formGroupElementInfo.iOrder = this.maxExtendOrder;
            this.formGroupElementInfo.iColNum = this.optionsFormat[0].value;
            this.formGroupElementInfo.sElementPropsJson.params = '';
            // this.formGroupElementInfo.sElementId = this.groupId + ':' + vPinyin.chineseToPinYin(this.formGroupElementInfo.sViewName);
        }
        Api.getDictTypeList('', response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message.error({ showClose: true, message: response.data.statusMessage });
                this.$log.error('dict/getDictTypeList', response.data.statusMessage);
                return;
            }
            this.dictDataList = response.data.content;
        });
    },
    // 定义变量
    data() {
        // let validateElementSpecial = (rule, value, callback) => {
        //     let strs = this.editItem.sElementFlg.split('_');
        //     if (this.formGroupElementInfo.elementType == strs[0]) {
        //         callback(this.$t('extendError.ERROR_ELEMENT_KEY_EXIST'));
        //     } else {
        //         callback();
        //     }
        // };
        let validateElementKey = (rule, value, callback) => {
            let sId = '';
            if (!this.isAddData) {
                sId = this.formGroupElementInfo.sId;
            }
            let param = {
                sId: sId,
                sGroupId: this.groupId,
                sElementKey: this.formGroupElementInfo.sViewName
            };
            Api.checkElementKey(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extendManage/checkElementKey', response.data.statusMessage);
                    return;
                }
                if (response.data.count > 0 && this.isAddData) {
                    callback(this.$t('extendError.ERROR_ELEMENT_KEY_EXIST'));
                } else {
                    callback();
                }
            });
        };
        let selectOptionsStrs = (rule, value, callback) => {
            let values = value.split('、');
            var nary = values.sort();
            let b = false;
            for (var i = 0; i < values.length; i++) {
                if (nary[i] == nary[i + 1]) {
                    b = true;
                }
            }
            if (b) {
                callback(this.$t('pgError.ERROR_OPTION_ENTERED_CANNOT_REPEATED'));
            } else {
                callback();
            }
        };
        return {
            radioFlag: false,
            elementWidthFlag: true,
            requestType: 'POST',
            viewUrl: '/extendManage/listProcessElementInfo',
            viewUrlParam: {
                sId: this.templateKey + ':'
            },
            queryConfigInfos: '/serviceSetup/queryConfigInfos',
            queryConfigInfosParam: {
                // currentPage: 1,
                // isPage: true,
                // pageSize: 10
            },
            dictDataList: [],
            optionsDemo: this.$t('pgCommon.BETWEEN_OPTIONS'),
            elementTypeDisabled: false,
            elementDisabled: false, //扩展元素下拉框可用性
            keyDisabled: false, //元素关键字可用性
            inputFlag: false, //输入框元素属性控制
            selectFlag: false, //下拉框属性控制
            taskAuthFlag: false, //权限元素属性控制
            showNameFlag: false,
            buttonSizes: [
                {
                    value: 'large',
                    label: this.$t('pgCommon.BIG')
                },
                {
                    value: 'default',
                    label: this.$t('pgCommon.CENTRE')
                },
                {
                    value: 'small',
                    label: this.$t('pgCommon.SMALL')
                }
            ],
            buttonTypes: [
                {
                    value: 'primary',
                    label: this.$t('pgCommon.MAIN_BUTTON')
                },
                {
                    value: '',
                    label: this.$t('pgCommon.DEFAULT_BUTTON')
                },
                {
                    value: 'dashed',
                    label: this.$t('pgCommon.DOTTED_LINE_BUTTON')
                },
                {
                    value: 'danger',
                    label: this.$t('pgCommon.WARNING_BUTTON')
                },
                {
                    value: 'link',
                    label: this.$t('pgCommon.LINK')
                }
            ],
            optionsRadio: [{ value: 0, label: this.$t('extendCommon.MANUAL_INPUT') }, { value: 1, label: this.$t('extendCommon.DICT') }, { value: 2, label: this.$t('URL') }],
            optionsAuths: [
                // {
                //     value: 'upLeavel',
                //     label: this.$t('pgCommon.DEFAULT_THE_SUPERIOR')
                // },
                // {
                //     value: 'downLeavel',
                //     label: this.$t('pgCommon.DEFAULT_THE_LOWER')
                // },
                {
                    value: 'handle',
                    label: this.$t('pgCommon.USER_MANUAL')
                }
            ],
            httpRequests: [
                {
                    value: 'myBaseUpload',
                    label: this.$t('pgCommon.YES')
                },
                {
                    value: 'myCommonUpload',
                    label: this.$t('pgCommon.NOT')
                }
            ],
            // 扩展元素数组
            optionsElement: [
                {
                    value: 'TdCheckboxGroup',
                    label: this.$t('pgCommon.TD_CHECKBOXGROUP')
                },
                {
                    value: 'TdRadio',
                    label: this.$t('pgCommon.TD_RADIO')
                },
                {
                    value: 'TdInput',
                    label: this.$t('pgCommon.TD_INPUT')
                },
                {
                    value: 'TdSelect',
                    label: this.$t('pgCommon.TD_SELECT')
                },
                {
                    value: 'TdTreeSelect',
                    label: this.$t('pgCommon.TD_TREE_SELECT')
                },
                {
                    value: 'TdUploadX',
                    label: this.$t('pgCommon.TD_UPLOAD')
                },
                {
                    value: 'TdGrid',
                    label: this.$t('pgCommon.TD_GRID')
                },
                {
                    value: 'TdDateTime',
                    label: this.$t('pgCommon.TD_TIME')
                },
                {
                    value: 'TdInputNumber',
                    label: this.$t('pgCommon.TD_NUMBER')
                },
                {
                    value: 'TdButton',
                    label: this.$t('pgCommon.TD_BUTTON')
                },
                {
                    value: 'nextUsers',
                    label: this.$t('pgCommon.NEXT_USERS')
                },
                {
                    value: 'nextGroups',
                    label: this.$t('pgCommon.NEXT_GROUPS')
                },
                {
                    value: 'showUsers',
                    label: this.$t('pgCommon.SHOW_USERS')
                },
                {
                    value: 'currPerson',
                    label: this.$t('pgCommon.DISPOSE_PERSON')
                },
                {
                    value: 'taskComments',
                    label: this.$t('pgCommon.COMMENTS')
                }
            ],
            sElementPropsJsons: [
                {
                    value: 'password',
                    label: this.$t('pgCommon.PASSWORD')
                },
                {
                    value: 'color',
                    label: this.$t('pgCommon.COLOR')
                },
                {
                    value: 'email',
                    label: this.$t('pgCommon.EMAIL')
                },
                {
                    value: 'text',
                    label: this.$t('pgCommon.TEXT')
                },
                {
                    value: 'textarea',
                    label: this.$t('pgCommon.TEXTAREA')
                },
                {
                    value: 'url',
                    label: this.$t('pgCommon.URL')
                }
            ],
            // 扩展元素属性数组
            optionsElementProps: [],
            // 扩展元素属性数组
            optionsElementEvents: [],
            //所属扩展组
            optionsGroup: [],
            // 表单信息
            formGroupElementInfo: {
                httpRequest: 'myCommonUpload',
                serviceId: '',
                sTag: '',
                selectRadio: 0,
                sId: '',
                sGroupId: '',
                sElementId: '',
                elementType: '',
                sViewName: '',
                iOrder: 1,
                iColNum: '',
                iHidden: 1,
                iNeeded: 1,
                iShowLabel: 0,
                sOptionName: '',
                sElementProp: '',
                sElementVal: '',
                sElementKey: '',
                sElementEvent: '',
                sElementPropVal: '',
                sElementEventVal: '',
                sElementPropsJson: {
                    defaultProps: {},
                    interfaceName: {},
                    params: {},
                    columns: []
                },
                queryUrl: '',
                searchUrl: '',
                defaultPropsId: 'id',
                defaultPropsLabel: 'caption',
                defaultPropsChildren: 'children',
                defaultPropsParentId: 'parentId',
                columnsParam: '',
                tableUrl: '',
                tableResquestType: '',
                sElementEventsJson: [],
                placeholder: '',
                defaultValue: '',
                selectOptionsStr: '',
                selectOptions: [],
                readOnly: 1,
                selects: 1,
                expand: 1,
                sRegex: '',
                sRegexInfo: '',
                nextAuth: '',
                showName: ''
            },
            submitLoading: false, // 保存按钮是否为加载状态
            optionsFormat: [
                {
                    value: 24,
                    label: this.$t('pgCommon.A_ROW')
                },
                {
                    value: 12,
                    label: this.$t('pgCommon.B_ROW')
                },
                {
                    value: 8,
                    label: this.$t('pgCommon.C_ROW')
                },
                {
                    value: 6,
                    label: this.$t('pgCommon.D_ROW')
                }
            ],
            requiredType: [
                //请求类型
                {
                    value: 0,
                    label: this.$t('extendCommon.IS_TRUE')
                },
                {
                    value: 1,
                    label: this.$t('extendCommon.DENY')
                }
            ],
            // 对表单进行数据验证
            rules: {
                elementType: [{ required: true, message: this.$t('pgError.ERROR_PLEASE_SELECT_ELEMENT'), trigger: 'change' }],
                sElementPropVal: [{ required: true, message: this.$t('pgError.ERROR_PLEASE_SELECT_ELEMENT'), trigger: 'change' }],
                sElementKey: [
                    { required: true, message: this.$t('extendError.ERROR_PLEASE_INPUT_ELEMENT_KEY'), trigger: 'blur' },
                    { pattern: window.tdExtend.regex.ENGLISH_AND_NUM_UNDERLINE, message: this.$t('extendRegex.ONLY_ENGLISH_NUM_UNDERLINE'), trigger: 'blur' }
                ],
                sViewName: [{ required: true, message: this.$t('pgError.ERROR_PLEASE_INPUT_SHOW_NAME'), trigger: 'change' }, { validator: validateElementKey, trigger: 'blur' }],
                sGroupId: [{ required: true, message: this.$t('extendError.ERROR_PLEASE_SELECT_GROUP'), trigger: 'change' }],
                selectOptionsStr: [{ required: true, message: this.$t('pgError.ERROR_PLEASE_INPUT_OPTIONS'), trigger: 'change' }, { validator: selectOptionsStrs, trigger: 'blur' }],
                nextAuth: [{ required: true, message: this.$t('pgError.ERROR_PLEASE_SELECT_AUTH'), trigger: 'change' }],
                showName: [{ required: true, message: this.$t('pgError.ERROR_PLEASE_INPUT_SHOW_NAME'), trigger: 'blur' }],
                method: [{ required: true, message: this.$t('pgError.ERROR_PLEASE_INPUT_EVENT'), trigger: 'blur' }],
                queryUrl: [{ required: true, message: this.$t('pgError.ERROR_PLEASE_INPUT_URL'), trigger: 'blur' }],
                searchUrl: [{ required: true, message: this.$t('pgError.ERROR_PLEASE_INPUT_URL'), trigger: 'blur' }],
                defaultPropsId: [{ required: true, message: this.$t('pgError.ERROR_PLEASE_INPUT_KEY'), trigger: 'blur' }],
                defaultPropsLabel: [{ required: true, message: this.$t('pgError.ERROR_PLEASE_INPUT_KEY'), trigger: 'blur' }],
                defaultPropsChildren: [{ required: true, message: this.$t('pgError.ERROR_PLEASE_INPUT_KEY'), trigger: 'blur' }],
                defaultPropsParentId: [{ required: true, message: this.$t('pgError.ERROR_PLEASE_INPUT_KEY'), trigger: 'blur' }],
                tableUrl: [{ required: true, message: this.$t('pgError.ERROR_PLEASE_INPUT_URL'), trigger: 'blur' }],
                columnsParam: [{ required: true, message: this.$t('pgError.ERROR_PLEASE_INPUT_TABLE_HEAD'), trigger: 'blur' }],
                tableResquestType: [{ required: true, message: this.$t('pgError.PLEASE_SELECT'), trigger: 'change' }]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        // 将元素属性转化为json串
        createPropsJson() {
            // 默认值设置
            if (this.formGroupElementInfo.elementType == 'TdInput' || this.formGroupElementInfo.elementType == 'TdDateTime') {
                this.formGroupElementInfo.sElementPropsJson.value = this.formGroupElementInfo.defaultValue;
            }
            // 只读设置
            if (this.formGroupElementInfo.readOnly == 0) {
                this.formGroupElementInfo.sElementPropsJson.disabled = true;
            } else {
                this.formGroupElementInfo.sElementPropsJson.disabled = false;
            }
            // 空白显示文字
            if (null != this.formGroupElementInfo.placeholder && '' != this.formGroupElementInfo.placeholder) {
                this.formGroupElementInfo.sElementPropsJson.placeholder = this.formGroupElementInfo.placeholder;
            }
            // 输入框和按钮类型
            if (null != this.formGroupElementInfo.sElementPropVal && '' != this.formGroupElementInfo.sElementPropVal) {
                this.formGroupElementInfo.sElementPropsJson.type = this.formGroupElementInfo.sElementPropVal;
            }
            if (null != this.formGroupElementInfo.buttonSize && '' != this.formGroupElementInfo.buttonSize) {
                this.formGroupElementInfo.sElementPropsJson.size = this.formGroupElementInfo.buttonSize;
            }
            // 拼装点击事件
            if (null != this.formGroupElementInfo.method && '' != this.formGroupElementInfo.method) {
                this.formGroupElementInfo.sElementEventsJson = [{ event: 'click', method: this.formGroupElementInfo.method }];
            }
            // 拼装点击事件
            if (null != this.formGroupElementInfo.changeMethod && '' != this.formGroupElementInfo.changeMethod) {
                this.formGroupElementInfo.sElementEventsJson = [{ event: 'change', method: this.formGroupElementInfo.changeMethod }];
            }
            // 批注
            if (this.formGroupElementInfo.elementType == 'taskComments') {
                this.formGroupElementInfo.sElementPropsJson.type = 'textarea';
            }
            // multiple是否多选
            if (this.formGroupElementInfo.selects == 0) {
                this.formGroupElementInfo.sElementPropsJson.multiple = true;
            } else {
                this.formGroupElementInfo.sElementPropsJson.multiple = false;
            }
            // 下拉框url请求模式
            if (this.formGroupElementInfo.elementType == 'TdSelect' && this.formGroupElementInfo.sElementPropsJson.url) {
                this.formGroupElementInfo.sElementPropsJson.isPage = true;
                this.formGroupElementInfo.sElementPropsJson.pageSize = 10;
                this.formGroupElementInfo.sElementPropsJson.requestType = this.requestType;
                if (this.formGroupElementInfo.sElementPropsJson.text) {
                    this.formGroupElementInfo.sElementPropsJson.sName = this.formGroupElementInfo.sElementPropsJson.text;
                }
            }
            // 树形下拉框
            if (this.formGroupElementInfo.elementType == 'TdTreeSelect') {
                // 禁用只读设置
                if (this.formGroupElementInfo.readOnly == 0) {
                    this.formGroupElementInfo.sElementPropsJson.popoverShow = false;
                } else {
                    this.formGroupElementInfo.sElementPropsJson.popoverShow = true;
                }
                // 是否使用组件内部方法获取树形数据
                this.formGroupElementInfo.sElementPropsJson.calInternal = true;
                if (this.formGroupElementInfo.sElementPropsJson.params != '') {
                    let param = JSON.parse(this.formGroupElementInfo.sElementPropsJson.params);
                    this.formGroupElementInfo.sElementPropsJson.params = param;
                }
                this.formGroupElementInfo.sElementPropsJson.defaultProps.children = this.formGroupElementInfo.defaultPropsChildren;
                this.formGroupElementInfo.sElementPropsJson.defaultProps.id = this.formGroupElementInfo.defaultPropsId;
                this.formGroupElementInfo.sElementPropsJson.defaultProps.label = this.formGroupElementInfo.defaultPropsLabel;
                this.formGroupElementInfo.sElementPropsJson.defaultProps.parentId = this.formGroupElementInfo.defaultPropsParentId;
                this.formGroupElementInfo.sElementPropsJson.interfaceName.query = this.formGroupElementInfo.queryUrl;
                this.formGroupElementInfo.sElementPropsJson.interfaceName.search = this.formGroupElementInfo.searchUrl;
                if (this.formGroupElementInfo.sElementPropsJson.defaultProps.imgName) {
                    this.formGroupElementInfo.sElementPropsJson.imgloading = true;
                }
            }
            //简易表格
            if (this.formGroupElementInfo.elementType == 'TdGrid') {
                this.formGroupElementInfo.sElementPropsJson.height = this.formGroupElementInfo.sElementPropsJson.height;
                this.formGroupElementInfo.sElementPropsJson.url = this.formGroupElementInfo.tableUrl;
                this.formGroupElementInfo.sElementPropsJson.requestType = this.formGroupElementInfo.tableResquestType;
                if (this.formGroupElementInfo.sElementPropsJson.urlParam != '') {
                    let param = JSON.parse(this.formGroupElementInfo.sElementPropsJson.urlParam);
                    this.formGroupElementInfo.sElementPropsJson.urlParam = param;
                }
                if (this.formGroupElementInfo.selects == 0) {
                    this.formGroupElementInfo.sElementPropsJson.hasMutiSelect = true;
                } else {
                    this.formGroupElementInfo.sElementPropsJson.hasMutiSelect = false;
                }
                // 创建表头数组
                if (this.formGroupElementInfo.columnsParam != '' && this.formGroupElementInfo.columnsParam != null) {
                    let options = this.formGroupElementInfo.columnsParam.split('、');
                    options.forEach(item => {
                        let param = item.split(':');
                        let obj = {
                            prop: param[0],
                            label: param[1]
                        };
                        this.formGroupElementInfo.sElementPropsJson.columns.push(obj);
                    });
                }
            }
            if (this.formGroupElementInfo.elementType == 'TdUploadX') {
                this.formGroupElementInfo.sElementPropsJson.autoUpload = true;
                this.formGroupElementInfo.sElementPropsJson.showFileList = false;
                this.formGroupElementInfo.sElementPropsJson.data = { serviceId: this.formGroupElementInfo.serviceId, ref: this.formGroupElementInfo.sViewName };
                this.formGroupElementInfo.sElementEventsJson = [{ event: 'httpRequest', method: this.formGroupElementInfo.httpRequest }];
            }
            // 下拉框字典请求模式
            if (this.formGroupElementInfo.selectRadio == 1) {
                this.formGroupElementInfo.sElementPropsJson.url = '/setting/dictController/getDictValuesByType';
                this.formGroupElementInfo.sElementPropsJson.urlParam = {
                    sTag: this.formGroupElementInfo.sTag
                };
                this.formGroupElementInfo.sElementPropsJson.isPage = true;
                this.formGroupElementInfo.sElementPropsJson.pageSize = 10;
                this.formGroupElementInfo.sElementPropsJson.requestType = 'POST';
                this.formGroupElementInfo.sElementPropsJson.sName = 'label';
            }
            // 手动抄送功能
            if (this.formGroupElementInfo.elementType == 'showUsers' && this.formGroupElementInfo.nextAuth == 'handle') {
                this.formGroupElementInfo.sElementPropsJson.multiple = true;
                this.formGroupElementInfo.sElementPropsJson.url = '/staffManager/getAllStaffInfo';
                this.formGroupElementInfo.sElementPropsJson.urlParam = {
                    // sSysFlg: sessionStorage.systemId
                    needPage: true
                };
                this.formGroupElementInfo.sElementPropsJson.isPage = true;
                this.formGroupElementInfo.sElementPropsJson.pageSize = 10;
                this.formGroupElementInfo.sElementPropsJson.requestType = 'POST';
                this.formGroupElementInfo.sElementPropsJson.keys = 'staffId';
                this.formGroupElementInfo.sElementPropsJson.text = 'staffName';
                this.formGroupElementInfo.sElementPropsJson.sName = 'staffName';
            }
            // 手动分配下环节用户
            if (this.formGroupElementInfo.elementType == 'nextUsers' && this.formGroupElementInfo.nextAuth == 'handle') {
                this.formGroupElementInfo.sElementPropsJson.multiple = true;
                this.formGroupElementInfo.sElementPropsJson.url = '/personInfo/queryPersonInfo';
                this.formGroupElementInfo.sElementPropsJson.urlParam = {
                    // sSysFlg: sessionStorage.systemId
                    needPage: true
                };
                this.formGroupElementInfo.sElementPropsJson.isPage = true;
                this.formGroupElementInfo.sElementPropsJson.pageSize = 10;
                this.formGroupElementInfo.sElementPropsJson.requestType = 'POST';
                this.formGroupElementInfo.sElementPropsJson.keys = 'id';
                this.formGroupElementInfo.sElementPropsJson.text = 'name';
                this.formGroupElementInfo.sElementPropsJson.sName = 'name';
            }
            // 手动分配下环节组织
            if (this.formGroupElementInfo.elementType == 'nextGroups' && this.formGroupElementInfo.nextAuth == 'handle') {
                this.formGroupElementInfo.sElementPropsJson.lazyloading = true;
                this.formGroupElementInfo.sElementPropsJson.imgloading = true;
                this.formGroupElementInfo.sElementPropsJson.defaultProps = {
                    parentId: 'parentId',
                    children: 'children',
                    id: 'id',
                    label: 'caption',
                    imgName: 'sIcon'
                };
                this.formGroupElementInfo.sElementPropsJson.isPaging = true;
                this.formGroupElementInfo.sElementPropsJson.multiple = true;
                this.formGroupElementInfo.sElementPropsJson.interfaceName = {
                    query: '/OrgStructureController/findOrgStructureTree',
                    search: '/OrgStructureController/findOrgStructureTree'
                };
                this.formGroupElementInfo.sElementPropsJson.params = {
                    needPage: true
                };
                this.formGroupElementInfo.sElementPropsJson.calInternal = true;
                // this.formGroupElementInfo.sElementPropsJson.checkStrictly = false;
                this.formGroupElementInfo.sElementPropsJson.expandOnClick = true;
            }
        },
        initAllFlag() {
            this.radioFlag = false;
            this.elementWidthFlag = true;
            this.inputFlag = false;
            this.selectFlag = false;
            this.taskAuthFlag = false;
            this.showNameFlag = false;
            this.formGroupElementInfo.showName = '';
        },
        // 初始化编辑数据
        initEditData() {
            let elementPropsJson = JSON.parse(this.editItem.sElementPropsJson);
            let elementEventJson = JSON.parse(this.editItem.sElementEventsJson);
            this.formGroupElementInfo.sElementPropsJson = elementPropsJson;
            this.formGroupElementInfo.sElementEventsJson = elementEventJson;

            this.formGroupElementInfo.iOrder = this.editItem.iOrder;
            this.formGroupElementInfo.iColNum = this.editItem.iColNum;
            this.formGroupElementInfo.iHidden = this.editItem.iHidden;
            this.formGroupElementInfo.iNeeded = this.editItem.iNeeded;
            this.formGroupElementInfo.iShowLabel = this.editItem.iShowLabel;
            if (elementPropsJson.placeholder) {
                this.formGroupElementInfo.placeholder = elementPropsJson.placeholder;
            }
            if (elementPropsJson.maxlength) {
                this.formGroupElementInfo.sElementPropsJson.maxlength = elementPropsJson.maxlength;
            }
            if (elementPropsJson.width) {
                this.formGroupElementInfo.sElementPropsJson.width = elementPropsJson.width;
            }
            if (elementPropsJson.value) {
                this.formGroupElementInfo.value = elementPropsJson.value;
            }
            if (elementPropsJson.disabled && elementPropsJson.disabled == true) {
                this.formGroupElementInfo.readOnly = 0;
            } else {
                this.formGroupElementInfo.readOnly = 1;
            }
            if (
                this.editItem.sElementFlg != 'nextUsers_handle' &&
                this.editItem.sElementFlg != 'nextUsers_downLeavel' &&
                this.editItem.sElementFlg != 'nextUsers_upLeavel' &&
                this.editItem.sElementFlg != 'nextGroups_handle' &&
                this.editItem.sElementFlg != 'nextGroups_downLeavel' &&
                this.editItem.sElementFlg != 'nextGroups_upLeavel' &&
                this.editItem.sElementFlg != 'showUsers_handle' &&
                this.editItem.sElementFlg != 'showUsers_downLeavel' &&
                this.editItem.sElementFlg != 'showUsers_upLeavel' &&
                this.editItem.sElementFlg != 'currPerson' &&
                this.editItem.sElementFlg != 'taskComments'
            ) {
                this.elementTypeDisabled = true;
                let para = {
                    currentPage: 1,
                    isPage: true,
                    pageNum: 1,
                    pageSize: 10,
                    sElementFlg: this.editItem.sElementFlg,
                    sId: this.editItem.sElementId
                };
                Api.listProcessElementInfo(JSON.stringify(para), response => {
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message.error({ showClose: true, message: response.data.statusMessage });
                        this.$log.error('/extendManage/listProcessElementInfo', response.data.statusMessage);
                        return;
                    }
                    let res = response.data.content[0];
                    if (
                        res.sElementType == 'TdSelect' ||
                        res.sElementType == 'TdTreeSelect' ||
                        res.sElementType == 'TdCheckboxGroup' ||
                        res.sElementType == 'TdRadio' ||
                        res.sElementType == 'TdGrid'
                    ) {
                        if (res.sElementType == 'TdCheckboxGroup' || res.sElementType == 'TdRadio') {
                            this.radioFlag = true;
                            this.elementWidthFlag = false;
                        }
                        this.formGroupElementInfo.sElementPropsJson.checked = elementPropsJson.checked;
                        this.formGroupElementInfo.elementType = res.sElementType;
                        this.formGroupElementInfo.sViewName = this.editItem.sElementFlg;
                        this.formGroupElementInfo.selects = elementPropsJson.multiple == true ? 0 : 1;
                        this.formGroupElementInfo.sElementPropsJson.url = elementPropsJson.url;
                        let options = JSON.parse(res.sOptionData);
                        if (options.length > 0) {
                            this.formGroupElementInfo.selectRadio = 0;
                            for (let i in options) {
                                if (i != 0) {
                                    this.formGroupElementInfo.selectOptionsStr = this.formGroupElementInfo.selectOptionsStr + '、' + options[i].value;
                                } else {
                                    this.formGroupElementInfo.selectOptionsStr = options[i].value;
                                }
                            }
                        } else if (elementPropsJson.urlParam && elementPropsJson.urlParam.sTag) {
                            this.formGroupElementInfo.selectRadio = 1;
                            this.formGroupElementInfo.sTag = elementPropsJson.urlParam.sTag;
                        } else {
                            this.formGroupElementInfo.selectRadio = 2;
                            this.formGroupElementInfo.sElementPropsJson.url = elementPropsJson.url;
                            this.formGroupElementInfo.sElementPropsJson.urlParam = elementPropsJson.urlParam;
                            this.formGroupElementInfo.sElementPropsJson.keys = elementPropsJson.keys;
                            this.formGroupElementInfo.sElementPropsJson.text = elementPropsJson.text;
                            this.requestType = elementPropsJson.requestType;
                        }
                    }
                    if (res.sElementType == 'TdTreeSelect') {
                        this.formGroupElementInfo.defaultPropsChildren = elementPropsJson.defaultProps.children;
                        this.formGroupElementInfo.defaultPropsId = elementPropsJson.defaultProps.id;
                        this.formGroupElementInfo.defaultPropsLabel = elementPropsJson.defaultProps.label;
                        this.formGroupElementInfo.defaultPropsParentId = elementPropsJson.defaultProps.parentId;
                        this.formGroupElementInfo.sElementPropsJson.defaultProps.imgName = elementPropsJson.defaultProps.imgName;
                        this.formGroupElementInfo.queryUrl = elementPropsJson.interfaceName.query;
                        this.formGroupElementInfo.searchUrl = elementPropsJson.interfaceName.search;
                        if (elementPropsJson.params != '') {
                            this.formGroupElementInfo.sElementPropsJson.params = JSON.stringify(elementPropsJson.params);
                        }
                    }
                    //简易表格
                    if (res.sElementType == 'TdGrid') {
                        this.formGroupElementInfo.sElementPropsJson.height = elementPropsJson.height;
                        this.formGroupElementInfo.tableUrl = elementPropsJson.url;
                        this.formGroupElementInfo.tableResquestType = elementPropsJson.requestType;
                        if (elementPropsJson.urlParam != '') {
                            this.formGroupElementInfo.sElementPropsJson.urlParam = JSON.stringify(elementPropsJson.urlParam);
                        }
                        this.formGroupElementInfo.selects = elementPropsJson.hasMutiSelect == true ? 0 : 1;
                        // 表头数组
                        if (elementPropsJson.columns != '' && elementPropsJson.columns != null) {
                            for (let i in elementPropsJson.columns) {
                                let data = elementPropsJson.columns[i].prop + ':' + elementPropsJson.columns[i].label;
                                if (i != 0) {
                                    this.formGroupElementInfo.columnsParam = this.formGroupElementInfo.columnsParam + '、' + data;
                                } else {
                                    this.formGroupElementInfo.columnsParam = data;
                                }
                            }
                        }
                    }
                    if (res.sElementType == 'TdInput') {
                        this.inputFlag = true;
                        this.formGroupElementInfo.elementType = res.sElementType;
                        this.formGroupElementInfo.sElementPropVal = elementPropsJson.type;
                        this.formGroupElementInfo.sViewName = this.editItem.sElementFlg;
                    }
                    if (res.sElementType == 'TdDateTime' || res.sElementType == 'TdInputNumber') {
                        this.formGroupElementInfo.elementType = res.sElementType;
                        this.formGroupElementInfo.sViewName = this.editItem.sElementFlg;
                    }
                    if (res.sElementType == 'TdButton') {
                        this.showNameFlag = true;
                        this.formGroupElementInfo.elementType = res.sElementType;
                        this.formGroupElementInfo.sElementPropVal = elementPropsJson.type;
                        this.formGroupElementInfo.showName = this.editItem.sViewName;
                        this.formGroupElementInfo.sName = this.editItem.sElementName;
                        this.formGroupElementInfo.buttonSize = elementPropsJson.size;
                    }
                    if (res.sElementType == 'TdUploadX') {
                        this.elementWidthFlag = false;
                        this.formGroupElementInfo.selects = elementPropsJson.multiple == true ? 0 : 1;
                        this.formGroupElementInfo.elementType = res.sElementType;
                        this.formGroupElementInfo.sViewName = this.editItem.sElementFlg;
                        this.formGroupElementInfo.serviceId = elementPropsJson.data.serviceId;
                    }
                });
            } else {
                let strs = this.editItem.sElementFlg.split('_');
                this.formGroupElementInfo.elementType = strs[0];
                this.formGroupElementInfo.nextAuth = strs[1];
                this.showNameFlag = true;
                this.elementTypeDisabled = true;
                this.selectFlag = false;
                this.inputFlag = false;
                this.formGroupElementInfo.showName = this.editItem.sViewName;
                this.formGroupElementInfo.sName = this.editItem.sElementName;
            }
            for (let key in elementEventJson) {
                if (elementEventJson[key].event == 'click') {
                    this.formGroupElementInfo.method = elementEventJson[key].method;
                }
                if (elementEventJson[key].event == 'httpRequest') {
                    this.formGroupElementInfo.httpRequest = elementEventJson[key].method;
                }
                if (elementEventJson[key].event == 'change') {
                    this.formGroupElementInfo.changeMethod = elementEventJson[key].method;
                }
            }
        },
        // 初始化所属扩展组下拉框数据
        initGroupList() {
            let param = {
                templateId: this.templateId,
                templateKey: this.templateKey
            };
            Api.getNodeInfo(param, response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.$log.error('queryTemplate', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('queryTemplate', response.data.statusMessage);
                    return;
                }
                this.optionsGroup = response.data.content;
                this.formGroupElementInfo.sGroupId = this.taskKey;
            });
        },
        // 下拉选项字典改变
        dictTagChange(val) {
            if (null == val || '' == val) {
                return;
            }
            let param = {
                sTag: val
            };
            Api.getDictValuesByType(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message.error({ showClose: true, message: response.data.statusMessage });
                    this.$log.error('setting/getDictValuesByType', response.data.statusMessage);
                    return;
                }
                let res = response.data.content;
                let options = [];
                for (let index = 0; index < res.length; index++) {
                    const element = res[index];
                    options.push({ value: element.value, label: element.label });
                }
                this.formGroupElementInfo.selectOptions = options;
            });
        },
        // 元素类型改变
        elementChange(data) {
            this.formGroupElementInfo.sOptionName = 'options';
            this.initAllFlag();
            if (data == 'TdInput') {
                this.inputFlag = true;
                this.sElementPropsJsons = [
                    {
                        value: 'password',
                        label: this.$t('pgCommon.PASSWORD')
                    },
                    {
                        value: 'color',
                        label: this.$t('pgCommon.COLOR')
                    },
                    {
                        value: 'email',
                        label: this.$t('pgCommon.EMAIL')
                    },
                    {
                        value: 'text',
                        label: this.$t('pgCommon.TEXT')
                    },
                    {
                        value: 'textarea',
                        label: this.$t('pgCommon.TEXTAREA')
                    },
                    {
                        value: 'url',
                        label: this.$t('pgCommon.URL')
                    }
                ];
            } else if (data == 'TdSelect') {
                this.selectFlag = true;
            } else if (data == 'TdTreeSelect') {
                this.selectFlag = true;
            } else if (data == 'nextUsers') {
                this.showNameFlag = true;
                this.taskAuthFlag = true;
                this.selectFlag = false;
                this.inputFlag = false;
                this.formGroupElementInfo.showName = this.$t('pgCommon.NEXT_USERS');
                this.formGroupElementInfo.sName = this.$t('pgCommon.NEXT_USERS');
            } else if (data == 'nextGroups') {
                this.showNameFlag = true;
                this.taskAuthFlag = true;
                this.selectFlag = false;
                this.inputFlag = false;
                this.formGroupElementInfo.showName = this.$t('pgCommon.NEXT_GROUPS');
                this.formGroupElementInfo.sName = this.$t('pgCommon.NEXT_GROUPS');
            } else if (data == 'showUsers') {
                this.showNameFlag = true;
                this.taskAuthFlag = true;
                this.selectFlag = false;
                this.inputFlag = false;
                this.formGroupElementInfo.showName = this.$t('pgCommon.SHOW_USERS');
                this.formGroupElementInfo.sName = this.$t('pgCommon.SHOW_USERS');
            } else if (data == 'currPerson') {
                this.showNameFlag = true;
                this.selectFlag = false;
                this.inputFlag = false;
                this.formGroupElementInfo.showName = this.$t('pgCommon.DISPOSE_PERSON');
                this.formGroupElementInfo.sName = this.$t('pgCommon.DISPOSE_PERSON');
            } else if (data == 'taskComments') {
                this.showNameFlag = true;
                this.selectFlag = false;
                this.inputFlag = false;
                this.formGroupElementInfo.showName = this.$t('pgCommon.COMMENTS');
                this.formGroupElementInfo.sName = this.$t('pgCommon.COMMENTS');
            } else if (data == 'TdButton') {
                this.showNameFlag = true;
                this.formGroupElementInfo.showName = this.$t('按钮');
                this.formGroupElementInfo.sName = this.$t('按钮');
            } else if (data == 'TdRadio') {
                this.radioFlag = true;
                this.elementWidthFlag = false;
            } else if (data == 'TdCheckboxGroup') {
                this.formGroupElementInfo.sOptionName = 'allList';
                this.radioFlag = true;
                this.elementWidthFlag = false;
            } else if (data == 'TdUploadX') {
                this.elementWidthFlag = false;
            }
        },
        groupChange(data) {
            if (this.$util.isEmpty(data)) {
                this.formGroupElementInfo.sElementKey = '';
            }
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    // 下环节权限元素，设置特定元素id
                    if (this.formGroupElementInfo.elementType == 'nextUsers' || this.formGroupElementInfo.elementType == 'nextGroups' || this.formGroupElementInfo.elementType == 'showUsers') {
                        this.formGroupElementInfo.sElementId = this.templateKey + ':' + this.formGroupElementInfo.elementType + '_' + this.formGroupElementInfo.nextAuth;
                    } else if (this.formGroupElementInfo.elementType == 'currPerson') {
                        this.formGroupElementInfo.sElementId = this.templateKey + ':' + this.formGroupElementInfo.elementType;
                    } else if (this.formGroupElementInfo.elementType == 'taskComments') {
                        this.formGroupElementInfo.sElementId = this.templateKey + ':' + this.formGroupElementInfo.elementType;
                    } else if (this.formGroupElementInfo.elementType == 'TdButton') {
                        this.formGroupElementInfo.sElementId = this.templateKey + ':' + this.taskKey + ':' + this.formGroupElementInfo.method;
                    } else {
                        // 普通元素，设置普通元素id
                        this.formGroupElementInfo.sElementId = this.templateKey + ':' + this.formGroupElementInfo.sViewName;
                    }
                    // 创建元素属性
                    this.createPropsJson();
                    this.submitLoading = true;
                    if (this.isAddData) {
                        let param = {
                            sGroupFlg: this.groupId
                        };
                        // 校验是否存在该表单
                        Api.checkGroupInfo(JSON.stringify(param), response => {
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('extendManage/checkGroupInfo', response.data.statusMessage);
                                return;
                            }
                            if (response.data.count == 0) {
                                // 不存在该表单，新建并保存该表单
                                var content = {
                                    sId: this.groupId,
                                    sName: this.taskName,
                                    sGroupFlg: this.groupId
                                };
                                Api.insertExtendGroup(JSON.stringify(content), response => {
                                    if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                        this.$log.error('extendManage/insertExtendGroup', response.data.statusMessage);
                                        this.submitLoading = false;
                                        return;
                                    }
                                    // 新增流程扩展表的关联关系
                                    let link = {
                                        sGroupId: this.groupId
                                    };
                                    Api.insertExtProLink(JSON.stringify(link), response => {
                                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                            this.$log.error('extendManage/insertExtProLink', response.data.statusMessage);
                                            this.submitLoading = false;
                                            return;
                                        }
                                    });
                                });
                            }
                        });
                        // 校验是否存在该元素
                        Api.checkElementSId(
                            JSON.stringify({
                                sId: this.formGroupElementInfo.sElementId
                            }),
                            response => {
                                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                    this.$log.error('extendManage/checkElementSId', response.data.statusMessage);
                                    return;
                                }
                                if (response.data.count == 0) {
                                    // 不存在该元素，新建并保存该元素
                                    let dataSource = 0;
                                    if (!this.formGroupElementInfo.selectRadio) {
                                        // 创建下拉选项数组
                                        if (this.formGroupElementInfo.selectOptionsStr != '' && this.formGroupElementInfo.selectOptionsStr != null) {
                                            let options = this.formGroupElementInfo.selectOptionsStr.split('、');
                                            options.forEach(item => {
                                                let obj = {
                                                    value: item,
                                                    label: item
                                                };
                                                if (this.formGroupElementInfo.selectRadio == 0 && this.formGroupElementInfo.readOnly == 0) {
                                                    obj.disabled = true;
                                                } else {
                                                    obj.disabled = false;
                                                }
                                                this.formGroupElementInfo.selectOptions.push(obj);
                                            });
                                        }
                                    } else if (this.formGroupElementInfo.selectRadio) {
                                        dataSource = 1;
                                    }
                                    let elementParam = {
                                        sId: this.formGroupElementInfo.sElementId,
                                        sName: '',
                                        sViewName: 'Process',
                                        sElementType: this.formGroupElementInfo.elementType,
                                        sElementFlg: '',
                                        iDataSource: dataSource,
                                        sOptionData: JSON.stringify(this.formGroupElementInfo.selectOptions),
                                        sRegex: this.formGroupElementInfo.sRegex,
                                        sRegexInfo: this.formGroupElementInfo.sRegexInfo
                                    };
                                    if (this.formGroupElementInfo.nextAuth == 'handle') {
                                        if (this.formGroupElementInfo.elementType == 'nextGroups') {
                                            elementParam.sElementType = 'TdTreeSelect';
                                        } else {
                                            elementParam.sElementType = 'TdSelect';
                                        }
                                    } else if (this.formGroupElementInfo.nextAuth == 'upLeavel' || this.formGroupElementInfo.nextAuth == 'downLeavel') {
                                        elementParam.sElementType = 'TdInput';
                                    }
                                    if (
                                        this.formGroupElementInfo.elementType == 'nextUsers' ||
                                        this.formGroupElementInfo.elementType == 'nextGroups' ||
                                        this.formGroupElementInfo.elementType == 'showUsers'
                                    ) {
                                        elementParam.sElementFlg = this.formGroupElementInfo.elementType + '_' + this.formGroupElementInfo.nextAuth;
                                        elementParam.sName = this.formGroupElementInfo.sName;
                                    } else if (this.formGroupElementInfo.elementType == 'currPerson' || this.formGroupElementInfo.elementType == 'taskComments') {
                                        elementParam.sElementType = 'TdInput';
                                        elementParam.sElementFlg = this.formGroupElementInfo.elementType;
                                        elementParam.sName = this.formGroupElementInfo.sName;
                                    } else if (this.formGroupElementInfo.elementType == 'TdButton') {
                                        elementParam.sElementFlg = this.formGroupElementInfo.method;
                                        elementParam.sName = this.formGroupElementInfo.showName;
                                    }
                                    Api.insertExtendElement(JSON.stringify(elementParam), response => {
                                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                            this.$message.error({ showClose: true, message: response.data.statusMessage });
                                            this.$log.error('extendManage/insertExtendElement', response.data.statusMessage);
                                            return;
                                        }
                                    });
                                    // 保存表单和元素关联关系和元素属性
                                    let content = {
                                        sGroupId: this.groupId,
                                        sElementId: this.formGroupElementInfo.sElementId,
                                        sElementKey: elementParam.sElementFlg,
                                        sViewName: this.formGroupElementInfo.showName == '' ? elementParam.sName : this.formGroupElementInfo.showName,
                                        iOrder: this.formGroupElementInfo.iOrder,
                                        iColNum: this.formGroupElementInfo.iColNum,
                                        iHidden: this.formGroupElementInfo.iHidden,
                                        iNeeded: this.formGroupElementInfo.iNeeded,
                                        iShowLabel: this.formGroupElementInfo.iShowLabel,
                                        sOptionName: this.formGroupElementInfo.sOptionName,
                                        sElementPropsJson: JSON.stringify(this.formGroupElementInfo.sElementPropsJson),
                                        sElementEventsJson: JSON.stringify(this.formGroupElementInfo.sElementEventsJson)
                                    };
                                    if (this.formGroupElementInfo.nextAuth == 'upLeavel' || this.formGroupElementInfo.nextAuth == 'downLeavel') {
                                        // 隐藏自动权限组件
                                        content.iHidden = 0;
                                    }
                                    Api.insertGroupElement(JSON.stringify(content), response => {
                                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                            this.$log.error('extendManage/insertGroupElement', response.data.statusMessage);
                                            this.submitLoading = false;
                                            return;
                                        }
                                        this.submitLoading = false;
                                        this.$message({ showClose: true, message: this.$t('extendCommon.ADD_SUCCESS'), type: 'success' });
                                        this.elementDialogClose();
                                        /* 编辑或添加完成需调用查询接口 */
                                        this.$emit('callbackQuery');
                                    });
                                } else {
                                    // 更新该元素
                                    let dataSource = 0;
                                    if (!this.formGroupElementInfo.selectRadio) {
                                        if (this.formGroupElementInfo.selectOptionsStr != '' && this.formGroupElementInfo.selectOptionsStr != null) {
                                            let options = this.formGroupElementInfo.selectOptionsStr.split('、');
                                            options.forEach(item => {
                                                let obj = {
                                                    value: item,
                                                    label: item
                                                };
                                                if (this.formGroupElementInfo.selectRadio == 0 && this.formGroupElementInfo.readOnly == 0) {
                                                    obj.disabled = true;
                                                } else {
                                                    obj.disabled = false;
                                                }
                                                this.formGroupElementInfo.selectOptions.push(obj);
                                            });
                                        }
                                    } else if (this.formGroupElementInfo.selectRadio) {
                                        dataSource = 1;
                                    }
                                    let elementParam = {
                                        sId: response.data.content[0].sId,
                                        sName: response.data.content[0].sName,
                                        sViewName: 'Process',
                                        sElementType: this.formGroupElementInfo.elementType,
                                        sElementFlg: response.data.content[0].sElementFlg,
                                        iDataSource: dataSource,
                                        sOptionData: JSON.stringify(this.formGroupElementInfo.selectOptions),
                                        sRegex: this.formGroupElementInfo.sRegex,
                                        sRegexInfo: this.formGroupElementInfo.sRegexInfo
                                    };
                                    if (this.formGroupElementInfo.nextAuth == 'handle') {
                                        if (this.formGroupElementInfo.elementType == 'nextGroups') {
                                            elementParam.sElementType = 'TdTreeSelect';
                                        } else {
                                            elementParam.sElementType = 'TdSelect';
                                        }
                                    } else if (this.formGroupElementInfo.nextAuth == 'upLeavel' || this.formGroupElementInfo.nextAuth == 'downLeavel') {
                                        elementParam.sElementType = 'TdInput';
                                    }
                                    if (
                                        this.formGroupElementInfo.elementType == 'nextUsers' ||
                                        this.formGroupElementInfo.elementType == 'nextGroups' ||
                                        this.formGroupElementInfo.elementType == 'showUsers'
                                    ) {
                                        elementParam.sElementFlg = this.formGroupElementInfo.elementType + '_' + this.formGroupElementInfo.nextAuth;
                                        elementParam.sName = this.formGroupElementInfo.sName;
                                    } else if (this.formGroupElementInfo.elementType == 'currPerson' || this.formGroupElementInfo.elementType == 'taskComments') {
                                        elementParam.sElementType = 'TdInput';
                                        elementParam.sElementFlg = this.formGroupElementInfo.elementType;
                                        elementParam.sName = this.formGroupElementInfo.sName;
                                    } else if (this.formGroupElementInfo.elementType == 'TdButton') {
                                        elementParam.sElementFlg = this.formGroupElementInfo.method;
                                        elementParam.sName = this.formGroupElementInfo.showName;
                                    }
                                    Api.updateExtendElement(JSON.stringify(elementParam), response => {
                                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                            this.$message.error({ showClose: true, message: response.data.statusMessage });
                                            this.$log.error('extendManage/updateExtendElement', response.data.statusMessage);
                                            return;
                                        }
                                    });
                                    // 保存表单和元素关联关系和元素属性
                                    let content = {
                                        sGroupId: this.groupId,
                                        sElementId: this.formGroupElementInfo.sElementId,
                                        sElementKey: response.data.content[0].sElementFlg,
                                        sViewName: this.formGroupElementInfo.showName == '' ? elementParam.sName : this.formGroupElementInfo.showName,
                                        iOrder: this.formGroupElementInfo.iOrder,
                                        iColNum: this.formGroupElementInfo.iColNum,
                                        iHidden: this.formGroupElementInfo.iHidden,
                                        iNeeded: this.formGroupElementInfo.iNeeded,
                                        iShowLabel: this.formGroupElementInfo.iShowLabel,
                                        sOptionName: this.formGroupElementInfo.sOptionName,
                                        sElementPropsJson: JSON.stringify(this.formGroupElementInfo.sElementPropsJson),
                                        sElementEventsJson: JSON.stringify(this.formGroupElementInfo.sElementEventsJson)
                                    };
                                    if (this.formGroupElementInfo.nextAuth == 'upLeavel' || this.formGroupElementInfo.nextAuth == 'downLeavel') {
                                        content.iHidden = 0;
                                    }
                                    Api.insertGroupElement(JSON.stringify(content), response => {
                                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                            this.$log.error('extendManage/insertGroupElement', response.data.statusMessage);
                                            this.submitLoading = false;
                                            return;
                                        }
                                        this.submitLoading = false;
                                        this.$message({ showClose: true, message: this.$t('extendCommon.ADD_SUCCESS'), type: 'success' });
                                        this.elementDialogClose();
                                        /* 编辑或添加完成需调用查询接口 */
                                        this.$emit('callbackQuery');
                                    });
                                }
                            }
                        );
                    } else {
                        // 校验是否存在该元素
                        Api.checkElementSId(
                            JSON.stringify({
                                sId: this.formGroupElementInfo.sElementId
                            }),
                            response => {
                                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                    this.$log.error('extendManage/checkElementSId', response.data.statusMessage);
                                    return;
                                }
                                if (response.data.count == 0) {
                                    // 不存在该元素，新建并保存该元素
                                    let dataSource = 0;
                                    if (!this.formGroupElementInfo.selectRadio) {
                                        // 创建下拉选项数组
                                        if (this.formGroupElementInfo.selectOptionsStr != '' && this.formGroupElementInfo.selectOptionsStr != null) {
                                            let options = this.formGroupElementInfo.selectOptionsStr.split('、');
                                            options.forEach(item => {
                                                let obj = {
                                                    value: item,
                                                    label: item
                                                };
                                                if (this.formGroupElementInfo.selectRadio == 0 && this.formGroupElementInfo.readOnly == 0) {
                                                    obj.disabled = true;
                                                } else {
                                                    obj.disabled = false;
                                                }
                                                this.formGroupElementInfo.selectOptions.push(obj);
                                            });
                                        }
                                    } else if (this.formGroupElementInfo.selectRadio) {
                                        dataSource = 1;
                                    }
                                    let elementParam = {
                                        sId: this.formGroupElementInfo.sElementId,
                                        sName: '',
                                        sViewName: 'Process',
                                        sElementType: this.formGroupElementInfo.elementType,
                                        sElementFlg: '',
                                        iDataSource: dataSource,
                                        sOptionData: JSON.stringify(this.formGroupElementInfo.selectOptions),
                                        sRegex: this.formGroupElementInfo.sRegex,
                                        sRegexInfo: this.formGroupElementInfo.sRegexInfo
                                    };
                                    if (this.formGroupElementInfo.nextAuth == 'handle') {
                                        if (this.formGroupElementInfo.elementType == 'nextGroups') {
                                            elementParam.sElementType = 'TdTreeSelect';
                                        } else {
                                            elementParam.sElementType = 'TdSelect';
                                        }
                                    } else if (this.formGroupElementInfo.nextAuth == 'upLeavel' || this.formGroupElementInfo.nextAuth == 'downLeavel') {
                                        elementParam.sElementType = 'TdInput';
                                    }
                                    if (
                                        this.formGroupElementInfo.elementType == 'nextUsers' ||
                                        this.formGroupElementInfo.elementType == 'nextGroups' ||
                                        this.formGroupElementInfo.elementType == 'showUsers'
                                    ) {
                                        elementParam.sElementFlg = this.formGroupElementInfo.elementType + '_' + this.formGroupElementInfo.nextAuth;
                                        elementParam.sName = this.formGroupElementInfo.sName;
                                    } else if (this.formGroupElementInfo.elementType == 'currPerson' || this.formGroupElementInfo.elementType == 'taskComments') {
                                        elementParam.sElementType = 'TdInput';
                                        elementParam.sElementFlg = this.formGroupElementInfo.elementType;
                                        elementParam.sName = this.formGroupElementInfo.sName;
                                    }
                                    Api.insertExtendElement(JSON.stringify(elementParam), response => {
                                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                            this.$message.error({ showClose: true, message: response.data.statusMessage });
                                            this.$log.error('extendManage/insertExtendElement', response.data.statusMessage);
                                            return;
                                        }
                                    });
                                    // 保存表单和元素关联关系和元素属性
                                    let content = {
                                        sGroupId: this.groupId,
                                        sElementId: this.formGroupElementInfo.sElementId,
                                        sElementKey: elementParam.sElementFlg,
                                        sViewName: this.formGroupElementInfo.showName == '' ? elementParam.sName : this.formGroupElementInfo.showName,
                                        iOrder: this.formGroupElementInfo.iOrder,
                                        iColNum: this.formGroupElementInfo.iColNum,
                                        iHidden: this.formGroupElementInfo.iHidden,
                                        iNeeded: this.formGroupElementInfo.iNeeded,
                                        iShowLabel: this.formGroupElementInfo.iShowLabel,
                                        sOptionName: this.formGroupElementInfo.sOptionName,
                                        sElementPropsJson: JSON.stringify(this.formGroupElementInfo.sElementPropsJson),
                                        sElementEventsJson: JSON.stringify(this.formGroupElementInfo.sElementEventsJson)
                                    };
                                    if (this.formGroupElementInfo.nextAuth == 'upLeavel' || this.formGroupElementInfo.nextAuth == 'downLeavel') {
                                        // 隐藏自动权限组件
                                        content.iHidden = 0;
                                    }
                                    Api.insertGroupElement(JSON.stringify(content), response => {
                                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                            this.$log.error('extendManage/insertGroupElement', response.data.statusMessage);
                                            this.submitLoading = false;
                                            return;
                                        }
                                        this.submitLoading = false;
                                        this.$message({ showClose: true, message: this.$t('extendCommon.ADD_SUCCESS'), type: 'success' });
                                        this.elementDialogClose();
                                        /* 编辑或添加完成需调用查询接口 */
                                        this.$emit('callbackQuery');
                                    });
                                } else {
                                    // 更新该元素
                                    let dataSource = 0;
                                    if (!this.formGroupElementInfo.selectRadio) {
                                        if (this.formGroupElementInfo.selectOptionsStr != '' && this.formGroupElementInfo.selectOptionsStr != null) {
                                            let options = this.formGroupElementInfo.selectOptionsStr.split('、');
                                            options.forEach(item => {
                                                let obj = {
                                                    value: item,
                                                    label: item
                                                };
                                                if (this.formGroupElementInfo.selectRadio == 0 && this.formGroupElementInfo.readOnly == 0) {
                                                    obj.disabled = true;
                                                } else {
                                                    obj.disabled = false;
                                                }
                                                this.formGroupElementInfo.selectOptions.push(obj);
                                            });
                                        }
                                    } else if (this.formGroupElementInfo.selectRadio) {
                                        dataSource = 1;
                                    }
                                    let elementParam = {
                                        sId: response.data.content[0].sId,
                                        sName: response.data.content[0].sName,
                                        sViewName: 'Process',
                                        sElementType: this.formGroupElementInfo.elementType,
                                        sElementFlg: response.data.content[0].sElementFlg,
                                        iDataSource: dataSource,
                                        sOptionData: JSON.stringify(this.formGroupElementInfo.selectOptions),
                                        sRegex: this.formGroupElementInfo.sRegex,
                                        sRegexInfo: this.formGroupElementInfo.sRegexInfo
                                    };
                                    if (this.formGroupElementInfo.nextAuth == 'handle') {
                                        if (this.formGroupElementInfo.elementType == 'nextGroups') {
                                            elementParam.sElementType = 'TdTreeSelect';
                                        } else {
                                            elementParam.sElementType = 'TdSelect';
                                        }
                                    } else if (this.formGroupElementInfo.nextAuth == 'upLeavel' || this.formGroupElementInfo.nextAuth == 'downLeavel') {
                                        elementParam.sElementType = 'TdInput';
                                    }
                                    if (
                                        this.formGroupElementInfo.elementType == 'nextUsers' ||
                                        this.formGroupElementInfo.elementType == 'nextGroups' ||
                                        this.formGroupElementInfo.elementType == 'showUsers'
                                    ) {
                                        elementParam.sElementFlg = this.formGroupElementInfo.elementType + '_' + this.formGroupElementInfo.nextAuth;
                                        elementParam.sName = this.formGroupElementInfo.sName;
                                    } else if (this.formGroupElementInfo.elementType == 'currPerson' || this.formGroupElementInfo.elementType == 'taskComments') {
                                        elementParam.sElementType = 'TdInput';
                                        elementParam.sElementFlg = this.formGroupElementInfo.elementType;
                                        elementParam.sName = this.formGroupElementInfo.sName;
                                    }
                                    Api.updateExtendElement(JSON.stringify(elementParam), response => {
                                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                            this.$message.error({ showClose: true, message: response.data.statusMessage });
                                            this.$log.error('extendManage/updateExtendElement', response.data.statusMessage);
                                            return;
                                        }
                                    });
                                    // 保存表单和元素关联关系和元素属性
                                    let content = {
                                        sId: this.editItem.sId,
                                        sGroupId: this.groupId,
                                        sElementId: this.formGroupElementInfo.sElementId,
                                        sElementKey: response.data.content[0].sElementFlg,
                                        sViewName: this.formGroupElementInfo.showName == '' ? elementParam.sName : this.formGroupElementInfo.showName,
                                        iOrder: this.formGroupElementInfo.iOrder,
                                        iColNum: this.formGroupElementInfo.iColNum,
                                        iHidden: this.formGroupElementInfo.iHidden,
                                        iNeeded: this.formGroupElementInfo.iNeeded,
                                        iShowLabel: this.formGroupElementInfo.iShowLabel,
                                        sOptionName: this.formGroupElementInfo.sOptionName,
                                        sElementPropsJson: JSON.stringify(this.formGroupElementInfo.sElementPropsJson),
                                        sElementEventsJson: JSON.stringify(this.formGroupElementInfo.sElementEventsJson)
                                    };
                                    if (this.formGroupElementInfo.nextAuth == 'upLeavel' || this.formGroupElementInfo.nextAuth == 'downLeavel') {
                                        content.iHidden = 0;
                                    }
                                    Api.updateGroupElement(JSON.stringify(content), response => {
                                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                            this.$log.error('extendManage/updateGroupElement', response.data.statusMessage);
                                            this.submitLoading = false;
                                            return;
                                        }
                                        this.submitLoading = false;
                                        this.$message({ showClose: true, message: this.$t('extendCommon.MODIFY_SUCCESS'), type: 'success' });
                                        this.elementDialogClose();
                                        /* 编辑或添加完成需调用查询接口 */
                                        this.$emit('callbackQuery');
                                    });
                                }
                            }
                        );
                    }
                }
            });
        },
        // 关闭窗口之前需要调用的方法
        elementDialogClose() {
            this.dialogVisible = false;
            this.$emit('elementDialogClose');
        },
        createJson(prop, val, props) {
            // 如果 val 被忽略
            if (typeof val === 'undefined' || val === '') {
                // 删除属性
                delete props[prop];
            } else {
                // 添加 或 修改
                props[prop] = val;
            }
        },
        strMapToObj(strMap) {
            let obj = Object.create(null);
            for (let [k, v] of strMap) {
                obj[k] = v;
            }
            return obj;
        },
        elementPorpChange(option) {
            this.formGroupElementInfo.sElementPropVal = '';
        },
        elementEventsChange(option) {
            this.formGroupElementInfo.sElementEventVal = '';
        },
        // 获取UUID
        getUUID() {
            return 'xxxx-xxxx-xxxx-xxxx-xxxx'.replace(/[xy]/g, function(c) {
                let r = (Math.random() * 16) | 0,
                    v = c == 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        }
    }
};
</script>
<style></style>
